import { ISelectItem } from "@/types";
import { ISales } from "@/types/sales";
import {
  IProposal,
  IProposalCreateRequest,
  IProposalListRequest,
  IProposalRequest,
  IProposalUpdateRequest,
} from "@/types/proposal";
import { ListRequest } from "./listRequest";
import { Sales } from "./sales";
import { ICompany } from "@/types/company";
import { Company } from "./company";
import { IPartner } from "@/types/partner";
import { Partner } from "./partner";
import { IChannel } from "@/types/channel";
import { Channel } from "./channel";
import { IProposalStatus } from "@/types/proposalStatus";
import { ProposalStatus } from "./proposalStatus";
import { IMember } from "@/types/member";
import { Member } from "./member";
import { ISkill } from "@/types/skill";
import { Skill } from "./skill";
import { IPost } from "@/types/post";
import { Post } from "./post";

export class Proposal implements IProposal {
  public id = 0;
  public company_id = 0;
  public partner_id = 0;
  public sales_id = 0;
  public channel_id = 0;
  public proposal_status_id = 0;
  public reward_lower = 0;
  public reward_upper = 0;
  public title = "";
  public summary = "";
  public span_start = "";
  public span_end = "";
  public created_at = "";
  public updated_at = "";

  public company: ICompany = new Company();
  public partner: IPartner = new Partner();
  public sales: ISales = new Sales();
  public channel: IChannel = new Channel();
  public proposal_status: IProposalStatus = new ProposalStatus();
  public members: IMember[] = [];
  public skills: ISkill[] = [];
  public posts: IPost[] = [];

  public constructor(props?: IProposal) {
    if (!props) {
      return;
    }
    Object.assign(this, props);
    this.company = new Company(props.company);
    this.sales = new Sales(props.sales);
    this.partner = new Partner(props.partner);
    this.channel = new Channel(props.channel);
    this.proposal_status = new ProposalStatus(props.proposal_status);
    if (props.members) {
      this.members = props.members.map((item) => new Member(item));
    }
    if (props.skills) {
      this.skills = props.skills.map((item) => new Skill(item));
    }
    if (props.posts) {
      this.posts = props.posts.map((item) => new Post(item));
    }
  }

  public static toSelectItem(proposal: IProposal): ISelectItem {
    return {
      text: proposal.title,
      value: proposal.id,
    };
  }
}

export class ProposalRequest implements IProposalRequest {
  public partner_id = undefined;
  public channel_id = 0;
  public proposal_status_id = 1;
  public reward_lower = undefined;
  public reward_upper = undefined;
  public title = "";
  public span_start = "";
  public span_end = "";
  public members: number[] = [];
  public skills: number[] = [];
  [key: string]: unknown;
}

export class ProposalCreateRequest
  extends ProposalRequest
  implements IProposalCreateRequest {}

export class ProposalUpdateRequest
  extends ProposalRequest
  implements IProposalUpdateRequest
{
  public constructor(props?: IProposal) {
    super();

    if (!props) {
      return;
    }
    Object.assign(this, props);
    if (props.members) {
      this.members = props.members.map((item) => item.id);
    }
    if (props.skills) {
      this.skills = props.skills.map((item) => item.id);
    }
  }
}

export class ProposalListRequest
  extends ListRequest
  implements IProposalListRequest
{
  public status?: number;
  public inprogress = false;
}
